import type { FC, ReactNode } from 'react'

import { SplitText } from '@/components/motion/split-text'
import { Reveal } from '@/components/motion/reveal'
import { ParallaxImage } from '@/components/motion/parallax-image'
import { Portrait } from '@/components/site/portrait'
import { aboutIntro, aboutStory } from '@/constants/about'
import { media } from '@/constants/media'

export const AboutStory: FC = (): ReactNode => {
    return (
        <section
            id='about'
            className='relative z-[2] flex w-full flex-col items-center gap-12 overflow-clip bg-background px-4 pb-section-lg pt-6 md:gap-20 lg:px-6'
        >
            <div className='flex w-full items-start gap-6'>
                <div aria-hidden='true' className='hidden flex-1 self-stretch md:block md:max-w-[32%] lg:max-w-[50%]' />

                <div className='flex w-full flex-col gap-2.5 py-6 md:flex-1'>
                    <SplitText
                        as='p'
                        text={aboutIntro}
                        effect='rise'
                        by='word'
                        stagger={0.03}
                        amount={0.3}
                        className='t-statement w-full max-w-full text-left text-foreground [text-wrap:balance] md:max-w-[90%]'
                    />
                </div>
            </div>

            <div className='flex w-full flex-col gap-6 lg:flex-row'>
                <div className='order-2 flex w-full flex-col items-end gap-6 py-6 md:items-start lg:order-1 lg:flex-1 lg:self-stretch lg:pr-6'>
                    <SplitText
                        as='p'
                        text={aboutStory}
                        effect='rise'
                        by='word'
                        stagger={0.012}
                        amount={0.2}
                        className='t-lead w-full max-w-[90%] text-left text-umber [text-wrap:pretty] md:max-w-[64%] lg:max-w-[86%]'
                    />
                </div>

                <div className='order-1 flex w-full justify-end py-6 lg:order-2 lg:flex-1'>
                    <div className='flex w-full flex-col items-end gap-12 md:max-w-[68%] md:flex-row md:items-end md:justify-center md:gap-6 lg:max-w-none lg:flex-1'>
                        <Reveal y={20} className='hidden w-full md:block md:max-w-[36%]'>
                            <ParallaxImage
                                src={media.workspaceDesk}
                                alt="A minimal desk with a large monitor, keyboard and mouse"
                                className='aspect-[0.815242] w-full'
                            />
                        </Reveal>

                        <Reveal y={20} delay={0.1} className='w-full max-w-[420px] md:flex-1'>
                            <Portrait className='w-full' />
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    )
}
